import {Component, OnInit} from '@angular/core';
import {AbstractProfileValidator} from "@biletix/features/performance/components/performance-page/ticket-content-viewport/ticket-selection-content/ticket-profile-validation/base/abstract-profile-validator";
import {FormBuilder} from "@angular/forms";

@Component({
    standalone: false,
    selector: 'btx-turkcell-profile-validator',
    templateUrl: './turkcell-profile-validator.component.html',
    styleUrls: ['./turkcell-profile-validator.component.scss']
})
export class TurkcellProfileValidatorComponent extends AbstractProfileValidator implements OnInit {

    isDiscountApplied: boolean = false;

    constructor(fb: FormBuilder) {
        super(fb);
    }

    ngOnInit(): void {
        this.initializeValidationFormGroup(this.validationFieldConfigs);
    }


    onValidateProfile() {
        if (this.validationFormGroup.invalid) {
            this.validationFormGroup.markAllAsTouched();
            return;
        }

        const validationFields: any[] = this.validationFormGroup.value;

        this.isDiscountApplied = !this.isDiscountApplied;
        //TODO: validate  profile
        //service call


    }
}
